var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Icon } from '@gerdau/hefesto';
import { EMappepMenuEventCodes } from '../Menu.utils';
import './DropdownMenu.styles.scss';
var DropdownMenu = function (_a) {
    var options = _a.options, closeDropdownMenu = _a.closeDropdownMenu, isUsingKeyboardToNavigate = _a.isUsingKeyboardToNavigate, setIsUsingKeyboardToNavigate = _a.setIsUsingKeyboardToNavigate, _b = _a.isSubLevel, isSubLevel = _b === void 0 ? false : _b, closeSubLevelDropdown = _a.closeSubLevelDropdown;
    var ulRef = useRef(null);
    useEffect(function () {
        if (isUsingKeyboardToNavigate && ulRef.current) {
            focusOnFirstLI();
        }
    }, []);
    var focusOnFirstLI = function () {
        var _a;
        if (ulRef.current) {
            ((_a = ulRef.current) === null || _a === void 0 ? void 0 : _a.firstChild).focus();
        }
    };
    var checkOutsideClick = function (event) {
        if (!!event &&
            !!ulRef.current &&
            !ulRef.current.contains(event.target)) {
            closeDropdownMenu();
        }
    };
    useEffect(function () {
        window.addEventListener('click', checkOutsideClick);
        return function () { return window.removeEventListener('click', checkOutsideClick); };
    });
    var getUlClassName = function () {
        var classList = ['hefesto-submenu-dropdown'];
        if (isSubLevel) {
            classList.push('hefesto-submenu-dropdown--sub-level');
        }
        return classList.join(' ');
    };
    var ulClassName = getUlClassName();
    return (_jsx("ul", __assign({ "data-testid": "hefesto-submenu-dropdown", ref: ulRef, className: ulClassName, tabIndex: 0 }, { children: options.map(function (option, idx) { return (_jsx(SubMenuDropDownItem, { item: option, closeDropdownMenu: closeDropdownMenu, isUsingKeyboardToNavigate: isUsingKeyboardToNavigate, setIsUsingKeyboardToNavigate: setIsUsingKeyboardToNavigate, closeSubLevelDropdown: closeSubLevelDropdown, isSubLevel: isSubLevel }, idx)); }) })));
};
var SubMenuDropDownItem = function (_a) {
    var item = _a.item, closeDropdownMenu = _a.closeDropdownMenu, isUsingKeyboardToNavigate = _a.isUsingKeyboardToNavigate, setIsUsingKeyboardToNavigate = _a.setIsUsingKeyboardToNavigate, isSubLevel = _a.isSubLevel, closeSubLevelDropdown = _a.closeSubLevelDropdown;
    var _b = useState(false), isOpenSubLevel = _b[0], setIsOpenSubLevel = _b[1];
    var liSubMenuDropDownItem = useRef(null);
    var hasSubMenuDropdown = !!item.options && item.options.length > 0;
    var openSubLevel = function () {
        var _a;
        if (item.disabled) {
            return;
        }
        if (isUsingKeyboardToNavigate) {
            (_a = liSubMenuDropDownItem.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        if (hasSubMenuDropdown) {
            setIsOpenSubLevel(true);
        }
    };
    var closeSubLevel = function () {
        if (hasSubMenuDropdown) {
            setIsOpenSubLevel(false);
        }
    };
    var focusOnNextSubMenuItem = function () {
        if (!liSubMenuDropDownItem.current) {
            return;
        }
        var getNextAbledSibling = function (currentLi) {
            var nextLi = currentLi.nextElementSibling;
            if (nextLi && isElementDisabledClassName(nextLi)) {
                return getNextAbledSibling(nextLi);
            }
            else {
                return nextLi;
            }
        };
        var nextElementSibling = getNextAbledSibling(liSubMenuDropDownItem.current);
        if (nextElementSibling) {
            nextElementSibling.focus();
            closeSubLevel();
        }
    };
    var focusOnPreviousSubMenuItem = function () {
        if (!liSubMenuDropDownItem.current) {
            return;
        }
        var getPreviousAbledSibling = function (currentLi) {
            var previousLi = currentLi.previousElementSibling;
            if (previousLi && isElementDisabledClassName(previousLi)) {
                return getPreviousAbledSibling(previousLi);
            }
            else {
                return previousLi;
            }
        };
        var previousElementSibling = getPreviousAbledSibling(liSubMenuDropDownItem.current);
        if (previousElementSibling) {
            previousElementSibling.focus();
        }
        else {
            closeDropdownMenu();
        }
    };
    var isElementDisabledClassName = function (element) {
        return element.classList.contains('hefesto-submenu-dropdown-item--disabled');
    };
    var onSelectItem = function () {
        if (item.disabled) {
            return;
        }
        if (hasSubMenuDropdown) {
            isOpenSubLevel ? closeSubLevel() : openSubLevel();
        }
        else {
            !!item.onClick && item.onClick();
            closeDropdownMenu();
        }
    };
    var onSubMenuDropdownItemKeyDown = function (event) {
        if (!Object.values(EMappepMenuEventCodes).find(function (code) { return code === event.code; })) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        if (!isUsingKeyboardToNavigate) {
            setIsUsingKeyboardToNavigate(true);
        }
        switch (event.code) {
            case EMappepMenuEventCodes.ARROW_DOWN: {
                focusOnNextSubMenuItem();
                return;
            }
            case EMappepMenuEventCodes.ARROW_UP: {
                focusOnPreviousSubMenuItem();
                closeSubLevel();
                return;
            }
            case EMappepMenuEventCodes.ARROW_RIGHT: {
                if (hasSubMenuDropdown) {
                    if (!isOpenSubLevel) {
                        openSubLevel();
                    }
                }
                return;
            }
            case EMappepMenuEventCodes.ARROW_LEFT: {
                if (isSubLevel && closeSubLevelDropdown) {
                    closeSubLevelDropdown();
                }
                else if (hasSubMenuDropdown && isOpenSubLevel) {
                    closeSubLevel();
                }
                return;
            }
            case EMappepMenuEventCodes.ENTER: {
                onSelectItem();
                return;
            }
            case EMappepMenuEventCodes.ESC: {
                closeDropdownMenu();
                return;
            }
            default: {
                return;
            }
        }
    };
    var getSubmenuItemLiClassName = function () {
        var classList = ['hefesto-submenu-dropdown-item'];
        if (item.disabled) {
            classList.push('hefesto-submenu-dropdown-item--disabled');
        }
        if (isOpenSubLevel) {
            classList.push('sub-level-open');
        }
        return classList.join(' ');
    };
    var submenuItemLiClassName = getSubmenuItemLiClassName();
    var getIconClassName = function () {
        var classList = ['hefesto-submenu-dropdown-item__icon'];
        if (item.disabled) {
            classList.push('hefesto-submenu-dropdown-item__icon--disabled');
        }
        return classList.join(' ');
    };
    var iconClassName = getIconClassName();
    return (_jsx("li", __assign({ className: submenuItemLiClassName, ref: liSubMenuDropDownItem, onKeyDown: onSubMenuDropdownItemKeyDown, onClick: function (e) {
            e.stopPropagation();
            onSelectItem();
        }, onMouseEnter: function () {
            if (isUsingKeyboardToNavigate) {
                setIsUsingKeyboardToNavigate(false);
            }
            openSubLevel();
        }, onMouseLeave: function () {
            if (isUsingKeyboardToNavigate) {
                setIsUsingKeyboardToNavigate(false);
            }
            closeSubLevel();
        }, tabIndex: 0 }, { children: _jsxs(_Fragment, { children: [_jsx("span", __assign({ className: "hefesto-submenu-dropdown-item__title" }, { children: item.title })), hasSubMenuDropdown && (_jsxs(_Fragment, { children: [_jsx("i", __assign({ className: iconClassName }, { children: _jsx(Icon, { option: "CaretRight", variant: "tertiary" }) })), isOpenSubLevel && (_jsx("div", __assign({ className: "hefesto-submenu-dropdown-sub-level" }, { children: _jsx(DropdownMenu, { closeDropdownMenu: closeDropdownMenu, options: item.options || [], isUsingKeyboardToNavigate: isUsingKeyboardToNavigate, setIsUsingKeyboardToNavigate: setIsUsingKeyboardToNavigate, isSubLevel: true, closeSubLevelDropdown: function () {
                                    var _a;
                                    closeSubLevel();
                                    if (isUsingKeyboardToNavigate) {
                                        (_a = liSubMenuDropDownItem.current) === null || _a === void 0 ? void 0 : _a.focus();
                                    }
                                } }) })))] }))] }) })));
};
export default DropdownMenu;
